import React from 'react';
import { ShieldAlert, MessageCircle, X } from 'lucide-react';

const LINK_PADRAO = 'https://api.whatsapp.com/send/?phone=5528999565056';

// Aviso de conta em análise por contestação de pagamento (bloqueio automático)
export const AccountBlockedNotice = ({ message, supportLink, onClose }) => (
  <div className="rounded-2xl border-2 border-red-300 bg-white/95 backdrop-blur p-4 shadow-xl
                  shadow-red-900/10 max-w-3xl lg:max-w-lg xl:max-w-xl mx-auto mb-4"
       data-testid="account-blocked-notice">
    <div className="flex items-start gap-3">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100">
        <ShieldAlert className="h-5 w-5 text-red-600" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="font-bold text-red-700">Conta em análise</p>
        <p className="text-sm text-gray-700 mt-0.5" data-testid="account-blocked-message">
          {message || 'Sua conta está em análise por uma contestação de pagamento. Fale com o suporte para regularizar.'}
        </p>
        <a href={supportLink || LINK_PADRAO} target="_blank" rel="noopener noreferrer"
           data-testid="account-blocked-support"
           className="mt-3 inline-flex items-center gap-2 rounded-full bg-gradient-to-r
                      from-emerald-500 to-green-600 px-4 py-2 text-sm font-bold text-white
                      shadow-md transition-transform hover:scale-[1.02] active:scale-95">
          <MessageCircle className="h-4 w-4" /> Falar com o suporte
        </a>
      </div>
      {onClose && (
        <button onClick={onClose} data-testid="account-blocked-close"
                className="text-gray-400 hover:text-gray-600" aria-label="Fechar">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  </div>
);

export default AccountBlockedNotice;
